import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import FAQs from "./Component/FAQs";
import CookiePolicy from "./Component/CookiePolicy";
import PolicyCenter from "./Component/PolicyCenter";
import {
  AccessibilityStatement,
  ComplaintsPolicy,
  CustomOrdersPolicy,
  IntellectualPropertyPolicy,
  OrderCancellationPolicy,
  PaymentSecurityPolicy,
  PrivacyChoicesPolicy,
  ProductCareSafetyPolicy,
  ProductInformationPolicy,
  PromotionsPricingPolicy,
  WarrantyRepairsPolicy,
  WebsiteDisclaimer,
} from "./Component/AdditionalPolicies";

function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/policies" element={<PolicyCenter />} />
          <Route path="/payments" element={<PaymentSecurityPolicy />} />
          <Route
            path="/orders-cancellations"
            element={<OrderCancellationPolicy />}
          />
          <Route path="/warranty-repairs" element={<WarrantyRepairsPolicy />} />
          <Route path="/care-safety" element={<ProductCareSafetyPolicy />} />
          <Route path="/custom-orders" element={<CustomOrdersPolicy />} />
          <Route
            path="/promotions-pricing"
            element={<PromotionsPricingPolicy />}
          />
          <Route
            path="/intellectual-property"
            element={<IntellectualPropertyPolicy />}
          />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/complaints" element={<ComplaintsPolicy />} />
          <Route path="/disclaimer" element={<WebsiteDisclaimer />} />
          <Route
            path="/product-information"
            element={<ProductInformationPolicy />}
          />
          <Route path="/privacy-choices" element={<PrivacyChoicesPolicy />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
